import { CustomFacetValue, FacetValueTreeStructure, TempCustomFacetValue } from '@catalog/const';
import { Level } from './facet-tree-level';

export class Tree implements FacetValueTreeStructure {
  root: any[] = [];
  data: CustomFacetValue[];

  constructor(data: CustomFacetValue[]) {
    data.map((item) => {
      const level = new Level(this.convertFacetValueType(item));
      this.mergeTree(level);
    });
  }

  convertFacetValueType(data: CustomFacetValue): TempCustomFacetValue {
    return { ...data, categoryPathArray: this.categoryPathToArray(data.code) };
  }

  mergeTree(level: Level, target = this.root): void {
    const rootLevel = target.find((item) => item.id === level.id);

    if (rootLevel && level.children.length > 0) {
      this.mergeTree(level.children[0], rootLevel.children);
    }

    if (rootLevel && level.children.length === 0) {
      const levelForMutation = target.find((item) => item.id === level.id);
      const indexOfLevelForMutation = target.findIndex((item) => item.id === level.id);
      const mutatedLevel = { ...level, children: levelForMutation.children };
      target.splice(indexOfLevelForMutation, 1, mutatedLevel);
    }

    if (!rootLevel) {
      target.push(level);
    }
  }

  categoryPathToArray(path: string): string[] {
    return path.split('/').slice(1);
  }
}
